import { generateColorFilterOptions } from 'PyzShopUi/scripts/product-detail-page/includes/filter-helper/colorFilter';
import { withProductFilter } from 'PyzShopUi/scripts/product-detail-page/hoc/withProductFilter';
import ColorFilterOptions
    from 'PyzShopUi/scripts/catalog-page/components/sidebar/filters/color-filter/ColorFilterOptions';
import { ISelectFilterOption } from 'PyzShopUi/scripts/shop-ui/components/search-page/interfaces';
import { generateSizeFilterOptions } from 'PyzShopUi/scripts/product-detail-page/includes/filter-helper/sizeFilter';
import SizeFilterOptions from 'PyzShopUi/scripts/catalog-page/components/sidebar/filters/size-filter/SizeFilterOptions';
import { IProductFilter, IVariantFilter } from 'PyzShopUi/scripts/product-detail-page/interfaces';

const FILTER_TYPE_COLORS = 'colors';
const FILTER_TYPE_SIZE = 'size';

export default function buildProductFilterComponent(filterData: IProductFilter[], preselectedFilters: any) {
    return filterData.reduce((result: IVariantFilter[], filter: IProductFilter) => {
        if (filter?.options?.length <= 1) {
            return result;
        }

        if (filter.type === FILTER_TYPE_COLORS) {
            const colorFilterOptionsMap = generateColorFilterOptions(filter.options);
            const colorFilterOptions = Array.from(colorFilterOptionsMap.values())
            const preSelectedFilter = colorFilterOptions.find(colorFilterOption => colorFilterOption.value === preselectedFilters?.[filter.type]);
            if (preSelectedFilter) {
                preSelectedFilter.selected = true;
            }

            const ColorFilterComponent = withProductFilter(
                ColorFilterOptions,
                FILTER_TYPE_COLORS,
                'color-filter',
                'Choose colour',
                (optionList: ISelectFilterOption[]): string => {
                    const selectedValue = optionList.filter(entry => entry.selected)[0]?.value;
                    return colorFilterOptionsMap.get(selectedValue)?.mappedColorName || selectedValue;
                });

            result.push({
                type: filter.type,
                component: ColorFilterComponent,
                options: colorFilterOptions,
            });
        } else if (filter.type === FILTER_TYPE_SIZE) {
            const sizeClassName = 'size-filter-pims-pdp';

            const sizeFilterOptions = generateSizeFilterOptions(filter.options);
            const preSelectedFilter = sizeFilterOptions.find(sizeFilterOption => sizeFilterOption.value === preselectedFilters?.[filter.type]);
            if (preSelectedFilter) {
                preSelectedFilter.selected = true;
            }

            const SizeFilterComponent = withProductFilter(
                SizeFilterOptions,
                FILTER_TYPE_SIZE,
                sizeClassName,
                'Choose size',
                (optionList: ISelectFilterOption[]): string => optionList.filter(entry => entry.selected)[0]?.value
            );

            result.push({
                type: filter.type,
                component: SizeFilterComponent,
                options: sizeFilterOptions,
            });
        }

        return result;
    }, []);
}
